import { List, Sheet, Assets, LedgerDetails } from "../Components/index.js";

export default [
    {
        path: "/audit/fd/stock",
        component: List,
        name: "audit.fd.stock",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/audit/fd/assets",
        component: Assets,
        name: "audit.fd.assets",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/audit/fd/sheet",
        component: Sheet,
        name: "audit.fd.sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/audit-ledger/update",
        component: LedgerDetails,
        name: "fd.audit.ledger.update",
        meta: {
            requiresAuth: true,
        },
    },
];
